import type { SVGProps } from "react";
const SuiFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#filter_svg__a)">
      <path
        fill="currentColor"
        d="M.29.332a.85.85 0 0 0-.258.505c-.057.443-.053 2.439.125 2.752l8.58 8.904c.236 2.44-.221 5.164.023 7.57.049.464.147.525.494.83.675.59 3.539 2.57 4.326 2.94s1.45.15 1.654-.619l.022-10.721 8.585-8.904c.178-.317.187-2.313.13-2.752-.085-.639-.748-.793-1.352-.838H1.379C1.034.027.545.105.29.332"
      />
    </g>
    <defs>
      <clipPath id="filter_svg__a">
        <path fill="#fff" d="M24-.001H0v24h24z" />
      </clipPath>
    </defs>
  </svg>
);
export default SuiFilterIcon;
